import { createFileRoute } from "@tanstack/react-router";
import { VisitCallPage } from "@/components/app/visits/visit-call-page";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/community/visits/$visitId")({
  beforeLoad: ({ context }) => guardRoute(context.me, "family-visits"),
  component: StaffVisitCall,
});

/** The call on the resident's tablet. */
function StaffVisitCall() {
  const { visitId } = Route.useParams();
  return <VisitCallPage kind="staff" visitId={visitId} />;
}
